import React from "react";

import ConfirmDialog from "../reusableComponent/confirmDialog/ConfirmDialog";
import InfoDialog from "../reusableComponent/infoDialog/InfoDialog";
import { NudgeAction } from "../../services/intent/types";

interface IntentModalProps {
  nudge: NudgeAction;
  onDismiss: () => void;
  onCta: () => void;
}

const IntentModal: React.FC<IntentModalProps> = ({ nudge, onDismiss, onCta }) => {
  if (nudge.cta) {
    return (
      <ConfirmDialog
        open
        title={nudge.title}
        body={nudge.text}
        primaryLabel={nudge.cta.label}
        secondaryLabel="Dismiss"
        onPrimary={onCta}
        onSecondary={onDismiss}
        onClose={onDismiss}
      />
    );
  }

  return <InfoDialog open title={nudge.title} body={nudge.text} onClose={onDismiss} />;
};

export default IntentModal;
